import { render, staticRenderFns } from "./ConsultingDetailView.vue?vue&type=template&id=efba0294&"
import script from "./ConsultingDetailView.vue?vue&type=script&lang=js&"
export * from "./ConsultingDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ConsultingDetailView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports